import './styles/ManagePermissionsSettings.scss';
import './styles/PermissionsManagement.scss';

import { Grid, Paper, Tab, Tabs } from '@mui/material';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';
import usePageHeading from 'utils/hooks/usePageHeading';

import { EntitlementList } from './components/EntitlementList';
import { PermissionList } from './components/PermissionList';
import { RoleList } from './components/RoleList';

export interface Role {
  id: number;
  name: string;
  archived: boolean;
}

export function ManagePermissionsSettings() {
  const [activeTab, setActiveTab] = useState(0);

  const { t } = useTranslation();

  usePageHeading({
    desktopOnly: true,
    heading: t(translations.pages.managePermissionsSettings.title())
  });

  const renderTabs = () => {
    return (
      <Tabs
        indicatorColor="primary"
        value={activeTab}
        onChange={(e, newVal) => setActiveTab(newVal)}
        className="permission-settings__tabs"
      >
        <Tab label={t(translations.pages.managePermissionsSettings.permissionScheme())} />
        <Tab label={t(translations.pages.managePermissionsSettings.roles())} />
        <Tab label={t(translations.pages.managePermissionsSettings.entitlements())} />
      </Tabs>
    );
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <PermissionList />;
      case 1:
        return <RoleList />;
      case 2:
        return <EntitlementList />;
      default:
        return null;
    }
  };

  return (
    <Grid container component={Paper} square elevation={1} className="permission-settings">
      {renderTabs()}
      {renderTabContent()}
    </Grid>
  );
}
